/**
 * Detection never reloads a page somebody is working in, so this only decides how
 * soon the offer appears. Returning to the app checks as well, which covers what an
 * interval is worst at: a phone that has had the app backgrounded for hours.
 */
export const UPDATE_POLL_INTERVAL_MS = 15 * 60 * 1000;
